import { useMutation } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

import { mediaManagerClient } from '@/lib/axios';
import { MutationConfig, queryClient } from '@/lib/react-query';
import { useNotificationStore } from '@/stores/notifications';
import { emptyStringValues } from '@/utils/objects';

import { TClipPeople, TPatchClipPeople } from '../types';

export async function patchClipPeople(body: TPatchClipPeople): Promise<TClipPeople> {
  return mediaManagerClient.patch(`/api/v1/clip_people/${body.id}`, emptyStringValues(body));
}

type MutationFn = typeof patchClipPeople;

type TUsePatchFeaturedPeopleParams = {
  config?: MutationConfig<MutationFn>;
  invalidateClipQueries?: boolean;
};

export function usePatchClipPeople({
  config = {},
  invalidateClipQueries = false,
}: TUsePatchFeaturedPeopleParams = {}) {
  const { t } = useTranslation();
  const { addErrorNotification, addSuccessNotification } = useNotificationStore();

  return useMutation({
    ...config,
    mutationFn: ({ silently = false, ...body }: TPatchClipPeople) =>
      patchClipPeople({ ...body, silently }),
    onError(error) {
      addErrorNotification(t('No se ha podido actualizar la persona de interés del corte'));
      console.error(error);
    },
    onSuccess(_data, variables: TPatchClipPeople) {
      if (!variables.silently) {
        addSuccessNotification(
          t('La persona de interés del corte se ha actualizado correctamente')
        );
      }
      if (invalidateClipQueries) {
        queryClient.invalidateQueries({ queryKey: ['clips'] });
      }
    },
  });
}
